import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('router', routerReducer, {})]
})
export class ShaRouterFeatureStateModule {}
